import loglevelnext from "loglevelnext";

const log = loglevelnext.create("dcmjs");

export { log };
export default log;
